{
  "CUSTOM_ROLE": {
    "HEADER": "Vlastné roly",
    "LEARN_MORE": "Zistiť viac o vlastných rolách",
    "DESCRIPTION": "Vlastné roly sú roly vytvorené vlastníkom účtu alebo administrátorom. Tieto roly možno priradiť agentom na definovanie ich prístupu a oprávnení v účte. Vlastné roly môžu byť vytvorené s konkrétnymi oprávneniami a úrovňami prístupu podľa potrieb organizácie.",
    "HEADER_BTN_TXT": "Pridať vlastnú rolu",
    "LOADING": "Načítavajú sa vlastné roly...",
    "SEARCH_404": "Neexistujú žiadne položky, ktoré by zodpovedali tejto požiadavke.",
    "PAYWALL": {
      "TITLE": "Aktualizujte na vytváranie vlastných rolí",
      "AVAILABLE_ON": "Funkcia vlastných rolí je dostupná iba v plánoch Business a Enterprise.",
      "UPGRADE_PROMPT": "Aktualizujte svoj plán pre prístup k pokročilým funkciám ako správa tímov, automatizácie, vlastné atribúty a ďalšie.",
      "UPGRADE_NOW": "Aktualizovať teraz",
      "CANCEL_ANYTIME": "Svoj plán môžete kedykoľvek zmeniť alebo zrušiť"
    },
    "ENTERPRISE_PAYWALL": {
      "AVAILABLE_ON": "Funkcia vlastných rolí je dostupná iba v platených plánoch.",
      "UPGRADE_PROMPT": "Aktualizujte na platený plán pre prístup k pokročilým funkciám ako protokoly auditu, kapacita agentov a ďalšie.",
      "ASK_ADMIN": "Ohľadom aktualizácie sa obráťte na svojho administrátora."
    },
    "LIST": {
      "404": "V tomto účte nie sú dostupné žiadne vlastné roly.",
      "TITLE": "Spravovať vlastné roly",
      "DESC": "Vlastné roly sú roly vytvorené vlastníkom účtu alebo administrátorom. Tieto roly možno priradiť agentom na definovanie ich prístupu a oprávnení v účte. Vlastné roly môžu byť vytvorené s konkrétnymi oprávneniami a úrovňami prístupu podľa potrieb organizácie.",
      "TABLE_HEADER": {
        "NAME": "Meno",
        "DESCRIPTION": "Popis",
        "PERMISSIONS": "Oprávnenia",
        "USAGE_COUNT": "Používa",
        "ACTIONS": "Akcie"
      }
    },
    "PERMISSIONS": {
      "CONVERSATION_MANAGE": "Spravovať všetky konverzácie",
      "CONVERSATION_UNASSIGNED_MANAGE": "Spravovať nepriradené konverzácie a tie priradené im",
      "CONVERSATION_PARTICIPATING_MANAGE": "Spravovať zúčastnené konverzácie a tie priradené im",
      "CONTACT_MANAGE": "Spravovať kontakty",
      "ACCESS_ALL_REPORTS": "Zobraziť všetky reporty",
      "KNOWLEDGE_BASE_MANAGE": "Spravovať znalostnú bázu",
      "DATA_ASSISTANT_MANAGE": "Spravovať dátového asistenta",
      "CALL_RECORDING_ACCESS": "Prístup ku všetkým nahrávkam hovorov"
    },
    "FORM": {
      "NAME": {
        "LABEL": "Meno",
        "PLACEHOLDER": "Zadajte prosím názov.",
        "ERROR": "Názov je povinný."
      },
      "DESCRIPTION": {
        "LABEL": "Popis",
        "PLACEHOLDER": "Zadajte prosím popis.",
        "ERROR": "Popis je povinný."
      },
      "PERMISSIONS": {
        "LABEL": "Oprávnenia",
        "ERROR": "Oprávnenia sú povinné."
      },
      "CANCEL_BUTTON_TEXT": "Zrušiť",
      "API": {
        "ERROR_MESSAGE": "Nepodarilo sa pripojiť k serveru. Skúste to prosím znova."
      }
    },
    "ADD": {
      "TITLE": "Pridať vlastnú rolu",
      "DESC": " Vlastné roly vám umožňujú vytvárať roly s konkrétnymi oprávneniami a úrovňami prístupu podľa potrieb organizácie.",
      "SUBMIT": "Odoslať",
      "API": {
        "SUCCESS_MESSAGE": "Vlastná rola bola úspešne pridaná."
      }
    },
    "EDIT": {
      "BUTTON_TEXT": "Upraviť",
      "TITLE": "Upraviť vlastnú rolu",
      "DESC": " Vlastné roly vám umožňujú vytvárať roly s konkrétnymi oprávneniami a úrovňami prístupu podľa potrieb organizácie.",
      "SUBMIT": "Aktualizovať",
      "API": {
        "SUCCESS_MESSAGE": "Vlastná rola bola úspešne aktualizovaná."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Vymazať",
      "API": {
        "SUCCESS_MESSAGE": "Vlastná rola bola úspešne odstránená.",
        "ERROR_MESSAGE": "Nepodarilo sa pripojiť k serveru. Skúste to prosím znova."
      },
      "CONFIRM": {
        "TITLE": "Potvrdiť odstránenie",
        "MESSAGE": "Určite chcete vymazať ",
        "YES": "Áno, odstrániť ",
        "NO": "Nie, ponechať "
      }
    }
  }
}
